(() => {
  const CLOSE_DELAY = 400;

  const initializeMegaMenu = (root = document) => {
    root.querySelectorAll('.tpe-desktop-nav__item--mega').forEach((item) => {
      if (item.dataset.tpeMegaMenuReady === 'true') return;

      const trigger = item.querySelector(':scope > a');
      let closeTimer;

      const open = () => {
        window.clearTimeout(closeTimer);
        item.classList.add('is-open');
        trigger?.setAttribute('aria-expanded', 'true');
      };

      const close = () => {
        window.clearTimeout(closeTimer);
        item.classList.remove('is-open');
        trigger?.setAttribute('aria-expanded', 'false');
      };

      const scheduleClose = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(close, CLOSE_DELAY);
      };

      item.dataset.tpeMegaMenuReady = 'true';
      trigger?.setAttribute('aria-expanded', 'false');
      item.addEventListener('pointerenter', open);
      item.addEventListener('pointerleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) scheduleClose();
      });
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        close();
        trigger?.focus();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeMegaMenu());
  } else {
    initializeMegaMenu();
  }

  document.addEventListener('shopify:section:load', (event) => initializeMegaMenu(event.target));

  // Smooth center-scroll for same-page category anchors (Trusted Gear dropdown).
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;
    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;
    const hash = href.slice(hashIndex + 1);
    if (!hash) return;
    const path = href.slice(0, hashIndex);
    if (path && window.location.pathname !== path) return;
    const target = document.getElementById(hash);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    history.replaceState(null, '', href);
  });
})();
